import { React, useState, useEffect } from "react";
import Select from "react-select";
import { countriesWithCodes } from "../../Helper/CountriesApi";
import Wrapper from "./Wrapper";

export default function CountrySelectForm({ setSelectedCountry, value }) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getCountries();
  }, []);

  const getCountries = async () => {
    const result = await countriesWithCodes();
    if (result.error) {
      return;
    }
    // const data = result.data.map((item, index) => {
    //   return {
    //     label: `${item.alpha2Code} + ${item.callingCodes[0]}`,
    //     value: "+" + item.callingCodes[0],
    //     default: index === 0 ? true : false,
    //   };
    // });
    // setCountries(data);
    setCountries([
      {
        label: `IL +972`,
        value: "+972",
        default: true,
      },
      {
        label: `PK +92`,
        value: "+92",
        default: true,
      },
    ]);
  };

  return (
    <Wrapper>
      <Select
        style={{ height: "55px" }}
        defaultValue={null}
        defaultInputValue={value}
        onChange={(country) => setSelectedCountry(country)}
        options={countries}
        placeholder="+972"
        className="CountryCodeSelect"
      />
    </Wrapper>
  );
}
